export enum BatchOperationTypes {
    UNKNOWN = 0,
    LISTINGS_CREATION = 1,
}
